'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryToggle = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.selectors = (0, _helpers.createSelectors)({
      selectors: {},
      context: context
    });
    this.els = {
      el: el
    };
    this.listeners = (0, _create2.default)(_helpers.Listeners);
    this.showContent = this.showContent.bind(this);
    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    this.showContent();
  },

  showContent: function showContent() {
    var param = this.getParameterByName(this.els.el.dataset.requiredQueryParamKey);

    if (param === this.els.el.dataset.requiredQueryParamValue) {
      this.els.el.style.display = 'block';
      this.els.el.setAttribute('aria-hidden', 'false');
    } else {
      this.els.el.style.display = 'none';
      this.els.el.setAttribute('aria-hidden', 'true');
    }
  },
  getParameterByName: function getParameterByName(name) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var queryToggle = (0, _create2.default)(QueryToggle);
  queryToggle.init({ el: el, context: context });
}